module.exports = __webpack_public_path__ + "static/media/NEGATIVE-2.d0c2614f.svg";